import { CaretLeftIcon } from '@phosphor-icons/react';
import type { ReactNode } from 'react';

import { OverflowTooltip } from '@/components/common/overflow-tooltip';

import type { DiscountDetail } from '../types';

import styles from './discount-detail-header.module.scss';

type Props = {
  discount: DiscountDetail;
  onBack: () => void;
  /** Top-right slot — ticket 07 passes the More-options menu; empty here. */
  actions?: ReactNode;
};

export function DiscountDetailHeader({ discount, onBack, actions }: Props) {
  return (
    <header className={styles.header}>
      <div className={styles.topRow}>
        <div className={styles.titleGroup}>
          <button type="button" className={styles.back} onClick={onBack} aria-label="Back">
            <CaretLeftIcon size={24} weight="bold" />
          </button>
          {/* Truncated + tooltipped so a long name never overflows the header (117323). */}
          <OverflowTooltip title={discount.name}>
            <h1 className={styles.name}>{discount.name}</h1>
          </OverflowTooltip>
        </div>
        <div className={styles.actions}>{actions}</div>
      </div>
    </header>
  );
}
